angular.module('TetherApp').factory('participantService', [
    '$http',
    function ($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getClientParticipants = function () {
            let uri = '/api/v1/client/participants/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipant = function (participantId) {
            let uri = '/api/v1/participants/' + participantId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipants = function (data) {
            let uri = '/api/v1/participants/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let searchParticipants = function (query, page) {
            let uri = '/api/v1/user/participants/search/' + query + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            if (page != undefined) {
                uri += '/?page=' + page;
            }
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let searchListParticipants = function (listId, query, page) {
            let uri = '/api/v1/user/participants/search-list/' + listId + '/' + query + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            if (page != undefined) {
                uri += '/?page=' + page;
            }
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteParticipant = function (participantId) {
            let uri = '/api/v1/participants/' + participantId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getGraphData = function (data) {
            let uri = '/api/v1/participants/graph/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getIndexCount = function (queryString) {
            if(queryString) {
                queryString = '?' + queryString;
            } else {
                queryString = '';
            }

            let uri = '/api/v1/participant/index-count/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                )
                + queryString;
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let toggleFlag = function (data) {
            return $http.put('/api/flagged-person', data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        return {
            getClientParticipants: getClientParticipants,
            getParticipant: getParticipant,
            getParticipants: getParticipants,
            searchParticipants: searchParticipants,
            searchListParticipants: searchListParticipants,
            deleteParticipant: deleteParticipant,
            getGraphData: getGraphData,
            getIndexCount: getIndexCount,
            toggleFlag: toggleFlag
        }

    }
]);
